export default function purge(val, suffix){
    return val === null || val === undefined ? 'N/A' : suffix ? val + suffix : val;
}